import Form from "antd/lib/form";

export const useAppFormWatch = Form.useWatch;